import { ready } from '@front/utils';
import { library, dom } from '@fortawesome/fontawesome-svg-core';

import {
    
} from '@fortawesome/free-brands-svg-icons';

import {
    faCircleQuestion, 
    faCircleUser,
    faEye,
    faEyeSlash,
    faStar as faStarEmpty,
    faThumbsUp,
} from '@fortawesome/free-regular-svg-icons';

import { 
    faBars,
    faCalendar,
    faCartShopping,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleExclamation,
    faCircleUser as faCirUser,
    faFile,
    faFileArrowDown,
    faFilePdf,
    faHome,
    faLocationDot,
    faMinus,
    faPen,
    faPlus,
    faSignOut,
    faSquare,
    faStar,
    faTrash,
    faUser,
    faXmark, 
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faBars,
    faCalendar,
    faCartShopping,
    faCheck,
    faCircle,
    faCircleExclamation,
    faCircleUser,
    faCirUser,
    faCircleQuestion,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faEye,
    faEyeSlash,
    faFile,
    faFileArrowDown,
    faFilePdf,
    faHome,
    faLocationDot,
    faMinus,
    faPen,
    faPlus,
    faSignOut,
    faSquare,
    faStar,
    faStarEmpty,
    faThumbsUp,
    faTrash,
    faUser,
    faXmark
);

ready(() => {
    dom.i2svg();
    dom.watch();
});